import React from 'react'
import cx from 'classnames'
import { User } from '@components/UI'

import {
  useRecordingMainParticipant,
  useRecordingParticipantsOnline,
  useRecordingScreenSharing
} from '../../hooks'
import ParticipantMedia, {
  useIsParticipantVideoEnabled
} from './ParticipantMedia'

const RecordingParticipantList = () => {
  const mainParticipant = useRecordingMainParticipant()
  const screenShare = useRecordingScreenSharing()
  let participants = useRecordingParticipantsOnline()

  participants = screenShare.sharing
    ? participants
    : participants.filter((p) => {
        if (!mainParticipant) return true
        return p._id !== mainParticipant._id
      })

  if (participants.length === 0) return null

  return (
    <div
      className={cx('gp-Media-participantList', {
        'is-screenShared': participants.some((p) => p.screen)
      })}
    >
      {participants.map((participant) => {
        return (
          <Participant
            key={participant._id}
            participantId={participant._id}
            isOnline={participant.online}
            image={participant.image}
          />
        )
      })}
    </div>
  )
}

const Participant = ({ participantId, isOnline, image }) => {
  const { enabled: isVideoEnabled, media } =
    useIsParticipantVideoEnabled(participantId)

  return (
    <div
      className={cx('gp-Media-participantInfo', {
        'is-videoOff': isOnline && !isVideoEnabled
      })}
    >
      <div className='gp-Media-participantInfo-video'>
        {isOnline & isVideoEnabled && <ParticipantMedia media={media} />}
        {isOnline && !isVideoEnabled && (
          <User name={name} img={image} hideName size='larger' />
        )}
      </div>
    </div>
  )
}
export default RecordingParticipantList
